import { render, staticRenderFns } from "./metrics-tile.vue?vue&type=template&id=58f6882a&"
import script from "./metrics-tile.vue?vue&type=script&lang=js&"
export * from "./metrics-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports